import { useEffect, useState } from "react";
import { api } from "./api";
import { getBundle } from "./offline";

const cache = {};

export const useMaster = (kind) => {
  const [items, setItems] = useState(cache[kind] || []);
  useEffect(() => {
    let live = true;
    api.get(`/master/${kind}`).then(({ data }) => { cache[kind] = data; if (live) setItems(data); })
      .catch(async () => { const b = await getBundle(); if (live && b?.[kind]) setItems(b[kind]); });
    return () => { live = false; };
  }, [kind]);
  return items;
};

export const clearMasterCache = () => Object.keys(cache).forEach((k) => delete cache[k]);

export const nameOf = (list, id) => list.find((x) => x.id === id)?.name || "—";
